/* eslint-disable */
import orderServiceStyles from '../../Services/Order/Order.service.styles';

/**
 * Create styles for `<OrderStatus />`
 * @param {Styles} styles The result of `createStyles`
 * @returns {Object} The `<OrderStatus />` styles
 */
const orderStatusStyles = ({ theme }) => ({
  ...orderServiceStyles.chipStyles({ theme }),
  chipNew: {
    cursor: `pointer`,
  },
  avatar: {
    color: `white`,
    backgroundColor: theme.palette.primary.main,
  },
});

export default orderStatusStyles;
